import script from "./VirtualTrainingSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./VirtualTrainingSummary.vue?vue&type=script&setup=true&lang=js"

import "./VirtualTrainingSummary.vue?vue&type=style&index=0&id=3f28a7b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f28a7b6"]])

export default __exports__